import React, { useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AppRouter } from './routes';
import { useThemeStore } from './services/themeStore';
import { createAppTheme } from './theme';
import { PWAInstallPrompt, PWAUpdateNotification } from './components/common';
import { AuthProvider } from './contexts/AuthContext';
import { useFirebaseSync } from './hooks/useFirebaseSync';
import { usePushNotifications } from './hooks/usePushNotifications';

/**
 * Component that initializes Firebase sync
 */
const FirebaseSyncInitializer: React.FC = () => {
  useFirebaseSync();
  return null;
};

/**
 * Component that initializes push notifications
 */
const PushNotificationsInitializer: React.FC = () => {
  usePushNotifications();
  return null;
};

/**
 * Main App component with theme provider and PWA components
 */
const App: React.FC = () => {
  const { mode } = useThemeStore();
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FirebaseSyncInitializer />
        <PushNotificationsInitializer />
        <AppRouter />
        <PWAInstallPrompt />
        <PWAUpdateNotification />
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
